import React from "react";

import MBOTWhiteLogo from "../assets/logo/login_logo.png";
import MBOTGraduate from "../assets/logo/adminlogo.png";

const AuthLayout = ({ children, rightContainerClassName }) => {
    return (
        <div className="row mt-0 m-0 auth-layout-container">
            {/* Left section for screen-specific content */}
            <section className="col-lg-5 col-12 d-flex justify-content-center align-items-center px-4 flex-column auth-left-screen text-center text-gray-50">
                {/* <img src={MBOTWhiteLogo} alt="MBOT Logo" className="img-fluid header-logo" />
                <h5 className="fw-600 fs-30 login-title">Welcome to Technologist and Technician Registration System (TReS)</h5>
                <h4 className="fs-22 fw-500 f-roboto text-white">
                    Sign in to Admin Portal
                </h4> */}
                {/* <img src={MBOTGraduate} alt="MBOT Graduate" className="img-fluid footer-img" /> */}
            </section>
            {/* Right section for children components (e.g., login or registration form) */}
            <section className={`col-lg-7 col-12 d-flex flex-column ${rightContainerClassName} align-items-start justify-content-center px-lg-5 px-3`}>
                {/* Renders the children components */}
                {children}
            </section>
        </div>
    );
};

export default AuthLayout;
